// A line or two of news about your treaties: answered, lapsed, or war. Each
// notice wears the picture of what happened (art audit P1): the diplomacy
// pool covers every treaty shape; refusals and lapses keep the plain line.
import type { Notice } from '../dynasty/useTreatyNews.js';
import { useT } from '../i18n/index.js';
import { noticeScene } from './sceneEvents.js';
import { sceneUrls } from './scenes.js';

export function TreatyNotices({
  notices,
  nameOf,
}: {
  readonly notices: readonly Notice[];
  readonly nameOf: (seat: number) => string;
}) {
  const t = useT();
  if (notices.length === 0) return null;
  return (
    <div className="flex w-full flex-col items-center gap-1.5" data-testid="treaty-notices">
      {notices.map((n) => {
        const scene = noticeScene(n.kind, n.state);
        return (
          <div
            key={n.id}
            className={`animate-notice-fade pointer-events-auto flex w-full max-w-[min(92vw,460px)] items-center gap-2 rounded-lg border bg-panel-scrim px-3 py-1.5 text-sm backdrop-blur-sm ${
              n.kind === 'war' || n.kind === 'refused' || n.kind === 'void'
                ? 'border-red-500/50 text-red-700 dark:text-red-300'
                : n.kind === 'accepted' || n.kind === 'wed' || n.kind === 'taken'
                  ? 'border-emerald-500/50 text-emerald-700 dark:text-emerald-300'
                  : 'border-border text-foreground'
            }`}
          >
            {scene && (
              <img
                src={sceneUrls(scene.group, scene.id as never).srcSmall}
                alt=""
                loading="lazy"
                className="h-9 w-14 shrink-0 rounded border border-border/40 object-cover"
                data-testid="treaty-notice-scene"
              />
            )}
            <span className="min-w-0 flex-1">
              {t(`treaty.news.${n.kind}`, {
                house: nameOf(n.other),
                treaty: t(`treaty.of.${n.state}`),
              })}
            </span>
          </div>
        );
      })}
    </div>
  );
}
